// extracted by mini-css-extract-plugin
module.exports = {"collectionField":"styles-module--collection-field--vQfca","fadeIn":"styles-module--fadeIn--2iRQb","slideInDown":"styles-module--slideInDown--1xI-c"};